import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import auth from '../../services/auth';
import GridContainer from "../Grid/GridContainer.js";
import GridItem from "../Grid/GridItem.js";
import Card from "../Card/Card.js";
import CardHeader from "../Card/CardHeader.js";
import CardIcon from "../Card/CardIcon.js";
import CardFooter from "../Card/CardFooter.js";
import CardBody from "../Card/CardBody.js";
import Danger from "../Typography/Danger.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import Table from "components/Table/Table.js";

// @material-ui/icons
import Icon from "@material-ui/core/Icon";
import swal from 'sweetalert';
import checatoken from '../checatoken';

function parseNumero(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }

    const texto = String(value).trim();
    if (!texto) {
        return null;
    }

    const normalizado = texto.includes(',')
        ? texto.replace(/\./g, '').replace(',', '.')
        : texto;
    const numero = Number(normalizado);

    return Number.isFinite(numero) ? numero : null;
}

export const numberFormat2 = (value) => {
    const numero = parseNumero(value);
    return numero === null ? '-' : new Intl.NumberFormat('pt-BR').format(Math.trunc(numero));
};

function formatarData(data) {
    if (!data) {
        return '-';
    }

    const dataParse = new Date(data);
    if (Number.isNaN(dataParse.getTime())) {
        return data;
    }

    return dataParse.toLocaleString('pt-BR');
}


class posicaotanque extends Component {

    state = {
        _Tanques: [],
        data: {

        },
        unid: {
            idUnidOPe: '',
            unidOpe: '',
        },
        ultimaMedicao: [],
        dadosMedidor: [],
    }

    async componentDidMount() {
            await checatoken();
            await this.GetTanque();
            await this.GetUltimaMedicao();
            await this.GetDadosMedidor();
    };

    async getDadosUnidade() {
        const chave = localStorage.getItem('lukos-token');
        const response = await auth.get('/unid/dados', {
            headers: {
                token: chave
            }
        });
        this.setState({ unid: response.data });
    }

    async GetTanque() {
        const chave = localStorage.getItem('lukos-token');
        await auth.get('/unid/gettanques', {
            headers: { token: chave },
        }).then(res => {
            console.log(res);
            this.setState({ _Tanques: res.data });
        })
            .catch(error => {
                console.log(error);
                swal("OPS!", "Não foi possível pegar os dados dos tanques. ", "error");
            })
    }    

    async GetUltimaMedicao() {
        const chave = localStorage.getItem('lukos-token');
        await auth.get('/unid/GetUltimaMedicao', {
            headers: { token: chave },
        }).then(res => {
            const dados = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : []);
            this.setState({ ultimaMedicao: dados });
        })
            .catch(error => {
                console.log(error);
                swal("OPS!", "Não foi possível carregar a última medição.", "error");
            })
    }

    async GetDadosMedidor() {
        const chave = localStorage.getItem('lukos-token');
        await auth.get('/unid/GetDadosMedidor', {
            headers: { token: chave },
        }).then(res => {
            const dados = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : []);
            this.setState({ dadosMedidor: dados });
        })
            .catch(error => {
                console.log(error);
                swal("OPS!", "Não foi possível carregar os dados do medidor.", "error");
            })
    }

    

    render() {
        const isLogged = !!localStorage.getItem('lukos-token');
        const tableDataUltimaMedicao = this.state.ultimaMedicao.map(item => ([
            item.TanqueCombustivel || '-',
            item.Operacional || '-',
            formatarData(item.DataMovimento),
            numberFormat2(item.Quantidade),
            numberFormat2(item.EstoqueAnterior),
            numberFormat2(item.Diferenca),
        ]));
        const tableDataDadosMedidor = this.state.dadosMedidor.map(item => ([
            item.idMovimentoCombustivel || '-',
            item.TanqueCombustivel || '-',
            item.Operacional || '-',
            formatarData(item.DataHoraCaptura),
            numberFormat2(item.Quantidade),
        ]));

        if (isLogged === false) {
            return(<Redirect to="/login" />)
          }
          else
          {
        
        return (<div>
            <GridContainer>
                {this.state._Tanques.map((Tanque, index) => (
                <GridItem xs={12} sm={6} md={4} key={index}>
                    <Card>
                        <CardHeader color={Tanque.CorCombustivel} stats icon>
                            <CardIcon color={Tanque.CorCombustivel} >
                                <Icon>local_gas_station_sharp</Icon>
                            </CardIcon>
                            <h6>{Tanque.UnidadeOperacional} - {Tanque.TanqueCombustivel}</h6>
                            <br></br>
                            <h3>{Tanque.Produto}</h3>
                            <h3 cl1assName='makeStyles-cardTitle-91'>
                                 {Tanque.EstoqueAtual} lts
                            </h3>
                            <h6>Operando com {Tanque.porcentagemTanque} % da capacidade </h6>
                        </CardHeader>
                        <CardFooter >
                        <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                        <CustomLinearProgress
                                variant="determinate"
                                color={Tanque.Corprogresso}
                                value={Tanque.porcentagemTanque}
                            />
{/* --                            <Line percent={Tanque.porcentagemTanque} strokeWidth="4" strokeColor={Tanque.Corprogresso} /> */}
                       </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Danger> 
                                <div className="makeStyles-defaultFontStyle-319">
                                    {Tanque.TerminoAproximado}
                                </div>
                            </Danger> 
                            
                        </GridItem>
                        </GridContainer>
                        </CardFooter>
                    </Card>
                </GridItem>)
                 )}
                {this.state.ultimaMedicao.length > 0 && (
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className="makeStyles-cardTitleWhite-87">Última medição aplicada.</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="primary"
                                    tableHead={["Tanque", "Produto", "Data Movimento", "Medição", "Estoque Anterior", "Diferenca"]}
                                    tableData={tableDataUltimaMedicao}
                                />
                            </CardBody>
                            <CardFooter>
                                Dados da ultima medicao retornados pelo endpoint da unidade.
                            </CardFooter>
                        </Card>
                    </GridItem>
                )}
                {this.state.dadosMedidor.length > 0 && (
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info">
                                <h4 className="makeStyles-cardTitleWhite-87">Dados do Medidor</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="info"
                                    tableHead={["ID Movimento", "Tanque", "Produto", "Data Hora Captura", "Medição"]}
                                    tableData={tableDataDadosMedidor}
                                />
                            </CardBody>
                            <CardFooter>
                                Dados capturados do medidor retornados pelo endpoint da unidade.
                            </CardFooter>
                        </Card>
                    </GridItem>
                )}
            </GridContainer>
        </div>
        )}

    };

    
}


export default posicaotanque;